export default [
  {
    path: '/fish-categories',
    name: 'fish-categories',
    component: () => import('@/views/pages/fish-category/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.fish-categories',
      resource: 'fish_category',
      action: 'list',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
    },
  },
  {
    path: '/fish-categories/add',
    name: 'add-fish-category',
    component: () => import('@/views/pages/fish-category/Add.vue'),
    meta: {
      pageTitle: 'breadcrumb.fish-categories',
      resource: 'fish_category',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/fish-categories',
          active: false,
        },
        {
          text: 'breadcrumb.add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/fish-categories/modify/:id',
    name: 'modify-fish-category',
    component: () => import('@/views/pages/fish-category/Modify.vue'),
    meta: {
      pageTitle: 'breadcrumb.fish-categories',
      resource: 'fish_category',
      action: 'edit',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/fish-categories',
          active: false,
        },
        {
          text: 'breadcrumb.modify',
          active: true,
        },
      ],
    },
  },
]
